import { LocationEvidence } from '@/types/LocationVerification.type';

export function resolveSyncedEvidenceUploadState(item: LocationEvidence): 'PENDING' | 'UPLOADED' {
  if (item.hasPhoto === false || item.imageUrl) {
    return 'UPLOADED';
  }
  return 'PENDING';
}

export function hasPendingPhotoEvidenceUpload(evidence: LocationEvidence[]): boolean {
  return evidence.some((item) => item.hasPhoto !== false && !item.imageUrl);
}
